export default "__VITE_ASSET__tJo6ViVi__"